import { create } from 'zustand';

export type ModalState = {
  key?: string;
  title: string;
  message: string;
  handleConfirm: Function;
  handleCancel: Function | null;
  cancelText: string | null;
  submitText: string | null;
  data?: any;
};

interface ModalStoreState {
  modalState: {
    key?: string;
    title: string;
    message: string;
    handleConfirm: Function;
    handleCancel: Function | null;
    cancelText: string | null;
    submitText: string | null;
  };
  displayModal: (modalState: ModalState) => void;
}

export const useModalStore = create<ModalStoreState>((set) => {
  return {
    modalState: {
      title: '',
      message: '',
      handleConfirm: () => {},
      handleCancel: null,
      cancelText: 'Cancel',
      submitText: 'Confirm',
    },
    displayModal: (modalState: ModalState) => {
      return set(() => {
        return { modalState };
      });
    },
  };
});
